import { render, staticRenderFns } from "./BurdenFile.vue?vue&type=template&id=20243f8a&scoped=true&"
import script from "./BurdenFile.vue?vue&type=script&lang=js&"
export * from "./BurdenFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20243f8a",
  null
  
)

export default component.exports